import React from 'react';

import { FormattedMessage } from 'react-intl';

import messages from './messages';
import ServiceDetailsField from './service-details-field';
import { useUtcFormattedDate } from '../../../../hooks/use-datetime-formats';
import { UserDateTimePropType } from '../../../../prop-types/user-date-time';

const SHIP_DATE_FIELD_ID = 'rate-card-ship-date';

const ShipDate = ({ shipDate }) => {
  const formattedShipDate = useUtcFormattedDate(shipDate);

  return (
    <ServiceDetailsField label={<FormattedMessage {...messages.shipDateLabel} />} labelId={SHIP_DATE_FIELD_ID} value={formattedShipDate} />
  );
};

export default ShipDate;

ShipDate.propTypes = {
  shipDate: UserDateTimePropType,
};
